<script lang="ts" setup>
	import { type Sizes } from "~/utils/enums";

	const props = withDefaults(
		defineProps<{
			size?: Sizes;
		}>(),
		{
			size: "large",
		}
	);
</script>

<template>
	<svg v-if="size === 'large'" width="58" height="53" viewBox="0 0 58 53" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="mask0_52_1915" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="58" height="53">
			<rect width="58" height="53" fill="white" />
		</mask>
		<g mask="url(#mask0_52_1915)">
			<rect x="54.5164" y="0.888062" width="3" height="58.016" rx="1.5" transform="rotate(30 54.5164 0.888062)" fill="black" />
			<rect x="1.89355" y="34.0333" width="32" height="3" rx="1.5" transform="rotate(30 1.89355 34.0333)" fill="black" />
		</g>
	</svg>

	<svg v-if="size === 'medium'" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="14.3103" y="0.498901" width="2" height="16" rx="1" transform="rotate(30 14.3103 0.498901)" fill="black" />
		<rect x="1.25" y="9.12439" width="8.99794" height="2" rx="1" transform="rotate(30 1.25 9.12439)" fill="black" />
	</svg>

	<svg v-if="size === 'small'" width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="11.3176" y="0.00891113" width="2" height="12.0147" rx="1" transform="rotate(30 11.3176 0.00891113)" fill="black" />
		<rect x="1.09863" y="5.67285" width="8.01789" height="2" rx="1" transform="rotate(30 1.09863 5.67285)" fill="black" />
	</svg>
</template>
